import React from 'react';
import {NavLink} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import homepage from '../assets/images/homepage.png';
import headerImage from '../assets/images/header.jpg';
import {Grid} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    flexGrow: 1,
    boxShadow: 0,
  },
  title: {
    flexGrow: 1,
    color: 'white',
    fontWeight: '200%',
    textAlign:'center',
    textShadow: '2px 2px #000'
  },
  languageIcons: {
    width: 100,
    backgroundColor: "rgba(200, 200, 200, 0.7);",
    height: 80,
    alignItems: 'right',
    textAlign: "right",
    color: '#444555',
    padding: 10
  },
  appbar: {
    backgroundColor: 'rgb(173,173,173)',
    backgroundImage: `url(${headerImage})`,
    color: 'black',
    margin: 'auto',
    textAlign: 'center',
    paddingTop: theme.spacing(1.5),
    display: 'inline-flex',
    backgroundRepeat: 'no-repeat',
    overflow: 'visible',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  menubar: {
    backgroundColor: 'rgb(248,249,250)',
    color: 'black',
    position: 'center',
    elevation: 2,
    boxShadow: 10,
    alignItems: 'center',
    textAlign: 'center',
  },
  toolbar: {
    marginTop: 10,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
    }
  },
  nav: {
    backgroundColor: 'transparent',
    display: 'flex',
    height: 24,
    float: 'center',
    color: 'darkgray',
    overflow: 'hidden',
    alignItems: 'center',
    textAlign: 'center',
    padding: '.5rem 1rem',
    boxSizing: 'border-box',
  },
  navLink: {
    float: 'center',
    color: 'darkgray',
    overflow: 'hidden',
    padding: '.5rem 1rem',
    boxSizing: 'border-box',
    fontWeight: '700',
    textDecoration: 'none',
  },
  activeMenu: {
    color: 'black',
  },
  gr: {
    color: "blue",
  },
  en: {
    color: "purple",
  },
}));

const Header = () => {
  const classes = useStyles();


  return <div className={classes.root}>
    <AppBar position="static" className={classes.appbar}>
      <Toolbar className={classes.toolbar}>
        <Grid container direction={'row'} alignItems={'center'}>
          <Grid item xs={2}>
            <NavLink to="/" activeClassName="is-active" exact={true}>
              <img src={homepage} width="120" alt=""/>
            </NavLink>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="h4" className={classes.title}>
              Οι περιπέτειες  των γλυπτών της Ακρόπολης
            </Typography>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
    <AppBar position="static" className={classes.menubar}>
      <Toolbar variant="dense">
        <nav className={classes.nav}>
          <NavLink to="/" activeClassName={classes.activeMenu} className={classes.navLink} exact={true}>Αρχική</NavLink>
          <NavLink to="/me-mia-matia" activeClassName={classes.activeMenu} className={classes.navLink} exact={true}>Με
            μια ματιά</NavLink>
          <NavLink to="/museums" activeClassName={classes.activeMenu} className={classes.navLink}
                   exact={true}>Μουσεία</NavLink>
          <NavLink to="/stories" activeClassName={classes.activeMenu} className={classes.navLink}
                   exact={true}>Ιστορίες</NavLink>
          <NavLink to="/evretirio" activeClassName={classes.activeMenu} className={classes.navLink}
                   exact={true}>Ευρετήριο</NavLink>

        </nav>
      </Toolbar>
    </AppBar>
  </div>
};

export default Header;
